import { Component, OnInit, ViewChild } from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validators} from '@angular/forms';
import {ApplicationService} from '../../shared/services/application.service';
import {CommonService} from '../../shared/services/common.service';
import {Application, ChecklistInstance, CheckListValueModel} from '../../models/ApplicationModel';
import {
  FacilityType,
  OwnershipType,
  MLevel,
  MRLevel,
  EducationLevel,
  QualificationType,
  ProfessionalType,
  RegionType,
  WoredaType,
  ZoneType,
  ProductType,
  SpecificProduct,
  ApplicationStatus,
  City, SpecificProductItem,
  ProfessionalControls, BranchOffice, FoodManufDoc
} from '../../models/CommonModels';
import {AlertService} from '../../shared/services/alert.service';
import {FileUploader} from 'ng2-file-upload';
import {AccountService} from '../../services/account.service';
import {UserDto} from '../../models/User';
import { NumberValidator } from '../../validators/number.validator';
import { NO_SCRIPT_INPUT_MESSAGE, withNoScriptValidators } from '../../shared/validators/no-script-input.validator';
import {environment} from '../../../environments/environment';
import {Document, PaymentInfo} from '../../models/ApplicationModel';
import * as Constants from '../../models/Constants';
import {
  ApplicationDetail,
  DocumentDetail,
  DraftApplicationModel,
  DraftFacilityData,
} from '../../models/ApplicationDetail';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentRef} from '../../models/DocumentRef';
import {FileLikeObject} from 'ng2-file-upload';
import { NgxSpinnerService } from 'ngx-spinner';
import { ChecklistConfigModel} from '../../models/ChecklistModel';
import {SettingsService} from '../../shared/services/settings.service';
import {ProfessionalConfigFilter, ProfessionalTypeConfig} from '../../models/ProfessionalType';
import {ErisLoginService} from '../../services/sso/eris-login.service';

// const URL = '/api/';
const URL =  environment.baseUrl + '/Attachment';
@Component({
  selector: 'app-edit-application',
  templateUrl: './edit-application.component.html',
  styleUrls: ['./edit-application.component.css']
})

export class EditApplicationComponent implements OnInit {

  @ViewChild('otherCity') otherCity;
  public draft: DraftApplicationModel;
  public tabList: Array<string> = ['facilityInfo', 'facilityLocation', 'facilityProfessionals', 'checklists', 'fileAttachments'];
  public tab: string;
  public buttonName: string;
  public facilityTypes: FacilityType[];
  public productTypes: ProductType[];
  public ownershipTypes: OwnershipType[];
  public mLevels: MLevel[];
  public mRLevels: MRLevel[];
  public allmRLevels: MRLevel[];
  public professionalTypes: ProfessionalType[];

  public uploader: FileUploader;
  public user: UserDto;
  public showManufacturerMenu = false;
  public showFoodManufacturerMenu = false;
  public showErrors = false;
  public applicationForm: FormGroup;
  public editMode = false;
  public editingDraft = false;
  public documents: Array<Document>;
  public editDocuments: Array<DocumentDetail>;
  public documentRefs: Array<DocumentRef>;
  public restrictedDocRefCount: number;
  public applicationNumber: string;
  public applicationID: number;
  public recipetNumber: string;
  public isProductTypeCosmetics = false;
  public showSpecificProduct = true;
  public removeFieldValue = true;
  public appDetail: ApplicationDetail;
  public specificProducts: SpecificProduct[] = [];
  public specificProductItems: SpecificProductItem[] = [];
  public appStatuses: ApplicationStatus[];
  private regionTypes: RegionType[];
  private woredaTypes: WoredaType[];
  private zoneTypes: ZoneType[];
  private branchList: BranchOffice[];
  private cities: City[];
  public draftApplicationID: number;
  private allowedFileType = ['pdf'];
  private maxFileSize: number = 6 * 1024 * 1024; // 6 MB
  private uploadErrorMessage: string;
  public constants: any = Constants;

  private checklistItems: Array<ChecklistInstance> = [];
  public checklists: ChecklistConfigModel[];
  public noChecklistAvailable = false;
  public productAndFacilityChanged = false;
  public paymentInfo: PaymentInfo;
  public smLetterOfExperienceDocRequired = true;
  public fileAttachmentIndex = 5;
  public showPayment = true;

  public professionalTypeConfigList: ProfessionalTypeConfig[];
  private fieldValue: null;


  constructor(private fb: FormBuilder, private appService: ApplicationService, private commonService: CommonService, private router: Router,
                private alertService: AlertService, private accService: AccountService, private route: ActivatedRoute,
                private spinner: NgxSpinnerService, private settingsService: SettingsService,
                private erisLoginService: ErisLoginService) {
                  console.log('formgroup', this.applicationForm );
      this.getFacilityTypes();
      this.getProductTypes();
      this.getOwnershipTypes();
      this.getmLevels();
      this.getmRLevels();
      this.getLocationTypes();
      this.getAppStatuses();
      this.getProfessionalTypes();
    }


  ngOnInit() {
    this.uploader = new FileUploader({
      url: URL,
      allowedFileType: this.allowedFileType,
      maxFileSize: this.maxFileSize,
      headers: [{name: 'Authorization', value: 'Bearer ' + this.accService.getTokenData()} ]
    });
    this.uploader.onWhenAddingFileFailed = (item, filter, options) => this.onWhenAddingFileFailed(item, filter, options);

    this.tab = 'facilityInfo';
    this.buttonName = 'Next';
    this.user = this.accService.getUserData();
    this.initializeForm();

    const id = this.route.snapshot.params['id'];
    const mode = this.route.snapshot.params['mode'];

    if (id) {
      this.editMode = true;
      if (mode && mode === 'draft') {
        this.editingDraft = true;
        this.appService.getDraftApplication(id).subscribe(
          data => {

            this.draft = data;
            const draftIdVal = data.id || (data as any)?.ID;
            if (draftIdVal) {
              this.draft.id = +draftIdVal;
              this.draftApplicationID = +draftIdVal;
            }
            data.draftFacilityData = Object.assign(new DraftFacilityData(), JSON.parse(data.applicationJsonData));
            this.appDetail = new ApplicationDetail(data.draftFacilityData, this.professionalTypes);
            this.applicationNumber = this.appDetail.applicationNumber;
            this.recipetNumber = this.appDetail.recieptNumber;
            this.applicationID = this.appDetail.id;
            if (this.appDetail.paymentInfos.length) {
              this.paymentInfo = new PaymentInfo(this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1]);
            }
            this.initializeEditForm(this.appDetail);
            if (this.appDetail.isLegacyData) {
              this.fileAttachmentIndex = 4;
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            }
            this.removeFieldValue = false; // don't remove SP after loading it for edit the first time
            this.productOrFacilityChange();
            this.specificProductChanges();
            this.manufacturingLevelChange();
            this.editDocuments = this.appDetail.documents;
            this.removeFieldValue = true;
            if (data.draftFacilityData && data.draftFacilityData.activeTab) {
              this.tabClicked(data.draftFacilityData.activeTab);
            }
          },
          err => {
            // this.errorMessage = err
          }
        );
      }else {
        this.appService.getApplication(id).subscribe(
          data => {

            this.appDetail = new ApplicationDetail(data, null);
            this.fileAttachmentIndex = 5;
            this.applicationNumber = this.appDetail.applicationNumber;
            this.recipetNumber = this.appDetail.recieptNumber;
            this.applicationID = this.appDetail.id;
            if (this.appDetail.paymentInfos.length) {
              this.paymentInfo = new PaymentInfo(this.appDetail.paymentInfos[this.appDetail.paymentInfos.length - 1]);
            }
            this.initializeEditForm(this.appDetail);
            this.getLocationTypes();
            if (this.appDetail.isLegacyData) {
              this.fileAttachmentIndex = 4;
              this.applicationForm.removeControl('payment');
              this.showPayment = false;
            }
            this.removeFieldValue = false; // don't remove SP after loading it for edit the first time
            this.productOrFacilityChange();
            this.specificProductChanges();
            this.manufacturingLevelChange();
            this.editDocuments = this.appDetail.documents;
            this.removeFieldValue = true;
          },
          err => {
            // this.errorMessage = err
          }
        );
      }

    }
    this.documents = [];
    this.documentRefs = [];
    this.applyApplicantNameOnProfession();
  }

  retrievePaymentDetail(detail) {
    this.paymentInfo = detail;
    console.log('payment detail ', detail);
  }

  initializeForm() {
    this.applicationForm = this.fb.group({
      facility: this.fb.group({
        ownerName: [''],
        ownerPhoneNumber: ['', [NumberValidator.isPhoneNumber]],
        focalPerson: [''],
        name: [''],
        facilityTypeID: [''],
        organizationTypeID: [''],
        productTypeID: [''],
        specificProductIDs: [[]],
        specificProductItemIDs: [[]],
        mLevelID: [''],
        mrLevelID: [''],
        tinNumber:['']
      }),
      location: this.fb.group({
        regionID: [-1],
        zoneID: [-1],
        woredaID: [-1],
        cityID: [-1],
        kebele: [''],
        houseNo: [''],
        phoneNo: ['', [NumberValidator.isPhoneNumber]],
        areaName: [''],
        branchOfficeID: ['']
      }),
      professionals: this.fb.group({}),
      checklist: this.fb.group({}),
      payment: this.fb.group({
        receiptNumber: ['', withNoScriptValidators()]
      })
    });
  }

  initializeEditForm(applicationDetail: ApplicationDetail) {

    this.applicationForm = this.fb.group({
      facility: this.fb.group({
        ownerName: [applicationDetail.facility.ownerName],
        ownerPhoneNumber: [applicationDetail.facility.ownerPhoneNumber, [NumberValidator.isPhoneNumber]],
        focalPerson: [applicationDetail.facility.focalPerson],
        name: [applicationDetail.facility.name],
        facilityTypeID: [applicationDetail.facility.facilityTypeID],
        organizationTypeID: [applicationDetail.facility.ownershipTypeID],
        productTypeID: [applicationDetail.productTypeID],
        specificProductIDs: [applicationDetail.specificProductIDs],
        specificProductItemIDs: [applicationDetail.specificProductItemIDs],
        mLevelID: [applicationDetail.mLevelID],
        mrLevelID: [applicationDetail.mrLevelID],
        tinNumber: [applicationDetail.facility.tinNumber, [Validators.pattern("^[0-9]{10}$")]]
      }),
      location: this.fb.group({
        regionID: [applicationDetail.location.regionID],
        zoneID: [applicationDetail.location.zoneID],
        woredaID: [applicationDetail.location.woredaID],
        cityID: [applicationDetail.location.cityID],
        kebele: [applicationDetail.location.kebele],
        houseNo: [applicationDetail.location.houseNo],
        phoneNo: [applicationDetail.location.phoneNo, [ NumberValidator.isPhoneNumber]],
        areaName: [applicationDetail.location.areaName],
        branchOfficeID: [applicationDetail.branchOfficeID],
      }),
      professionals: this.fb.group({}),
      checklist: this.fb.group({}),
      payment: this.fb.group({
        receiptNumber: ['', withNoScriptValidators([Validators.required])]
      })
    });
    if (applicationDetail.paymentInfos.length) {
      this.applicationForm.get('payment').get('receiptNumber').setValue(applicationDetail
        .paymentInfos[applicationDetail.paymentInfos.length - 1].recieptNumber);
    }
  }

  activeTab(tab) {
    return this.tab === tab;
  }

  notFirstTab() {
    return !(this.getTabNumber() === 0);
  }

  nextClicked() {
    let index: number = this.getTabNumber();
    if (index !== 4) { // next button
    this.showErrors = false;
    this.tabClicked(this.tabList[index + 1])
    }else{
    // submit button
    if (this.editMode && !this.editingDraft) {
      this.editApplication(false);
    } else if (this.editMode && this.editingDraft) {

      if (this.appDetail.id) {
        this.editApplication(true);
      } else {
        this.createApplication();
      }
    } else {
      this.createApplication();
    }
  }
   
  }

  saveClicked() {
    this.spinner.show();

    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    this.createChecklistObject();

    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(), configuredProfessions, this.checklistItems, this.appDetail);
    appl.documents = this.documents;
    appl.paymentInfos = [this.paymentInfo];

    if (this.editMode && !this.editingDraft) {
      const id = this.route.snapshot.params['id'];
      appl.id = id;
      appl.applicationNumber = this.applicationNumber;
      appl.recieptNumber = this.recipetNumber;
      if (this.documents.length === 0) {
        for (let i = 0; i < this.editDocuments.length; i++) {
          appl.documents.push(new Document(this.editDocuments[i]));
        }
      }
      this.appDetail.paymentInfos[0] = this.paymentInfo;
      appl.paymentInfos = this.appDetail.paymentInfos;
    }
    appl.activeTab = this.tab;
    if (this.documents.length === 0 && this.editDocuments && this.editDocuments.length > 0) {
      for (let i = 0; i < this.editDocuments.length; i++) {
        appl.documents.push(new Document(this.editDocuments[i]));
      }
    }
    if (!this.draft) {
      this.draft  = new DraftApplicationModel(JSON.stringify(appl), this.erisLoginService.getUserId());
      if (this.draftApplicationID) {
        this.draft.id = this.draftApplicationID;
      }
    } else {
      if (!this.draft.id && this.draftApplicationID) {
        this.draft.id = this.draftApplicationID;
      }
      this.draft.applicationJsonData = JSON.stringify(appl);
      this.draft.createdBy = this.erisLoginService.getUserId();
    }
    this.appService.saveDraftApplication(this.draft).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application saved as a draft Successfully');
        const sId = res.id || (res as any)?.ID || (res as any)?.Id;
        if (sId) {
          this.draft.id = sId;
          this.draftApplicationID = sId;
        }
      } else {
        this.alertService.error('Unable to save your application as a draft!');
      }
    });
  }

  backClicked() {
   this.tabClicked(this.tabList[this.getTabNumber() - 1]);
  }

  getTabNumber() {
    let tabinput: string = this.tab;
    return this.tabList.findIndex(function (element: string) {
      return element === tabinput;
      });
  }

  getProductTypes(facilityTypeID = 0): void {
    this.commonService.getProductTypes(facilityTypeID).subscribe(productTypes => this.productTypes = productTypes);
  }

  getFacilityTypes(): void {
    this.commonService.getFacilityTypes(true).subscribe(facilityTypes => this.facilityTypes = facilityTypes);
  }

  getOwnershipTypes(): void {
    this.commonService.getOwnershipTypes().subscribe(organizationTypes => this.ownershipTypes = organizationTypes);
  }

  getmLevels(): void {
    this.commonService.getMLevels().subscribe(mLevels => this.mLevels = mLevels);
  }

  getmRLevels(): void {
    this.commonService.getMRLevels().subscribe(mRLevels => {
        this.mRLevels = mRLevels;
        this.allmRLevels = mRLevels;
      }
    );
  }

  getAppStatuses() {
    this.commonService.getApplicationStatuses().subscribe(appStatuses => this.appStatuses = appStatuses);
  }

  getProfessionalTypes(): void {
    this.commonService.getProfessionalTypes().subscribe(professionalTypes => {
      this.professionalTypes = professionalTypes;
    });
  }

  get Constants() {
    return Constants;
  }

  getLocationTypes() {
    this.commonService.getRegionTypes().subscribe(regionTypes => {
      this.regionTypes = regionTypes;
    });

    if (this.appDetail && this.appDetail.facility && this.appDetail.location && this.appDetail.location.zoneID) {
      this.commonService.getWoredaTypesByZone(this.appDetail.location.zoneID).subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
    }
    else {
      this.commonService.getWoredaTypes().subscribe(woredaTypes => {
        this.woredaTypes = woredaTypes;
      });
    }

    if (this.appDetail && this.appDetail.facility && this.appDetail.location && this.appDetail.location.regionID) {
      this.commonService.getZoneTypesByRegion(this.appDetail.location.regionID).subscribe(zoneTypes => {
        this.zoneTypes = zoneTypes;
      });
    }
    else {

      this.commonService.getZoneTypes().subscribe(zoneTypes => {
        this.zoneTypes = zoneTypes;
      });

    } 
        
    this.commonService.getCities().subscribe(cities => {
      this.cities = cities;
    });
    this.commonService.getBranchOffices().subscribe(branches => {
      this.branchList = branches.map((branch) => { const cityName =  branch.city ? branch.city.name : ''
        branch.label = branch.name + ' (' + cityName + ')'; return branch; });
    });
  }

  tabClicked(tab) {
    this.tab = tab;
    if (tab === 'fileAttachments') {
        this.buttonName = 'Submit';
      
    } else {
      this.buttonName = 'Next';
    }

  }

  createChecklistObject() {
    this.checklistItems = [];
    let controlArray = Object.keys(this.applicationForm.get('checklist')['controls']);

    for (let checklistControl of controlArray) {
      if (this.applicationForm.get('checklist').get(checklistControl).value.length) {
        const checklistRefIndex = this.checklists.findIndex(item => item.checklist.id.toString() === checklistControl);
        let newChecklistItem: ChecklistInstance = new ChecklistInstance();
        let checklistValue: CheckListValueModel = new CheckListValueModel();
        checklistValue.valueCode = this.applicationForm.get('checklist').get(checklistControl).value.toString().toUpperCase();
        checklistValue.name = this.applicationForm.get('checklist').get(checklistControl).value.toString();
        newChecklistItem.checkListValue = checklistValue;
        newChecklistItem.checklistID = this.checklists[checklistRefIndex].checklist.id;
        newChecklistItem.applicationID = this.appDetail ? this.appDetail.id : undefined;
        this.checklistItems.push(newChecklistItem);
      }
    }
  }

  createApplication() {
    this.spinner.show();
    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    this.createChecklistObject();
    
    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(), configuredProfessions, this.checklistItems, null);
    appl.documents = this.documents;
    appl.paymentInfos = [this.paymentInfo];

    this.appService.addApplication(appl, false).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application Submitted Successfully');
        this.applicationForm.reset();
        this.uploader.clearQueue();
        if(this.editingDraft){
          const id = this.route.snapshot.params['id'];
          this.appService.deleteDraftApplication(id).subscribe(res=>{
            console.log('Draft version of the application has been discarded');
          },err=>{
            console.log('Unable to discard the draft version of the application');
            this.alertService.error('Unable to discard the draft version of the application');
          })
        }
        setTimeout(() => {
          this.router.navigateByUrl('/applications/list/' + res.id) ;
        }, 1000);
      } else {
        this.alertService.error('Unable to submit your application!');
      }
    },
    err =>{

      this.spinner.hide();
      if(err.status == 406){
        this.alertService.error('The receipt number is already taken!');
      }else{
        this.alertService.error('Unable to submit your application!');
      }

    });
  }

  editApplication(editDraft: boolean) {
    this.spinner.show();
    
    const configuredProfessions = this.professionalTypeConfigList.map(pc => {
      return pc.professionalType.professionalTypeCode;
    });

    this.createChecklistObject();

    let appl = new Application(this.applicationForm.value, this.erisLoginService.getUserId(), configuredProfessions,
              this.checklistItems, this.appDetail);
    if (!editDraft) {
      const id = this.route.snapshot.params['id'];
      appl.id = id;
    } else {

      appl.id = this.appDetail.id;

    }

    appl.recieptNumber = this.recipetNumber;
    appl.applicationNumber = this.appDetail.applicationNumber;
    appl.documents = this.documents;
    this.appDetail.paymentInfos[0] = this.paymentInfo;
    appl.paymentInfos = this.appDetail.paymentInfos;
    if (this.appDetail.applicationStatusCode === 'PREF') {
      // after editing the status should change to ASDP
      appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === 'ASDP').id;
    } else if (this.appDetail.applicationStatusCode === 'VERF') {
      // after editing the status should change to PRSC
      appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === 'PRSC').id;
    }

    if (this.appDetail.isLegacyData) {
      appl.applicationStatusID = this.appStatuses.find(a => a.applicationStatusCode === Constants.LEGACY_DATA_EDITED_CODE).id;
    }
      this.appService.updateApplication(appl).subscribe(res => {
      this.spinner.hide();
      if (res) {
        this.alertService.success('Application Edited Successfully');
        this.applicationForm.reset();
        this.uploader.clearQueue();
        if(editDraft){
          this.appService.deleteDraftApplication(this.draftApplicationID).subscribe(res=>{
            console.log('Draft version of the application has been discarded');
          },err=>{
            console.log('Unable to discard the draft version of the application');
            this.alertService.error('Unable to discard the draft version of the application');
          })
        }
      
          this.router.navigateByUrl('/applications/list/' + appl.id);
      
      } else {
        this.alertService.error('Unable to edit your application!');
      }
    });
  }

  productOrFacilityChange() {
    const selectedFacilityType = this.applicationForm.value.facility.facilityTypeID;
    const productTypeId = this.applicationForm.value.facility.productTypeID;
    
    this.showManufacturerMenu = selectedFacilityType === Constants.MANUFACTURER_ID;
    this.showFoodManufacturerMenu = false;

    if (productTypeId && productTypeId !== '' && selectedFacilityType && selectedFacilityType !== '') {

      this.fetchConfiguredProfessionals();

      const product = this.productTypes.find(function (x) {
        return x.id === productTypeId;
      });

      const facilityType = this.facilityTypes.find(function (x) {
        return x.id === selectedFacilityType;
      });

      this.isProductTypeCosmetics = (product.name === Constants.PRODUCT_TYPE_COSMETICS ||  product.name === Constants.PRODUCT_TYPE_SMALL_SCALE_COSMETICS) && facilityType.name !== Constants.MANUFACTURER;

      this.commonService.getFilteredSpecificProducts(this.applicationForm.value.facility.facilityTypeID,
        this.applicationForm.value.facility.productTypeID).subscribe(specificProducts => this.specificProducts = specificProducts);
      
      if (this.removeFieldValue) {
        this.applicationForm.get('facility').get('specificProductIDs').setValue([]);
        this.applicationForm.get('facility').get('mrLevelID').setValue('');
      }

      this.setSpecificProductValidator(product, facilityType);

      if (this.appDetail && this.appDetail.isLegacyData) {
        this.noChecklistAvailable = true;
      } else {
        this.getCheckListConfig(selectedFacilityType, productTypeId);
      }

      this.productAndFacilityChanged = true;
    }

    if (selectedFacilityType && selectedFacilityType === Constants.MANUFACTURER_ID) {
      this.getProductTypes(selectedFacilityType);
      this.applicationForm.get('facility').get('mLevelID');
    } else {
        this.getProductTypes(selectedFacilityType);
        this.applicationForm.get('facility').get('mLevelID').clearValidators();
      }
    this.applicationForm.get('facility').get('mLevelID').updateValueAndValidity();

    if (productTypeId) {
      this.repopulateRefList();
    }

  }

  isChecklistTabDisabled(): boolean {
    let disabled = true;
    if (this.productAndFacilityChanged) {
      disabled = this.noChecklistAvailable ?
        this.applicationForm.get('professionals').invalid : this.applicationForm.get('checklist').invalid;
    }
    return disabled;
  }

  fileAttachmentTabDisabled(): boolean {
    return !(this.appDetail && this.appDetail.isLegacyData && !this.applicationForm.controls.professionals.invalid)
      && this.isChecklistTabDisabled();
  }

  getCheckListConfig(selectedType, productTypeId) {
    const checklistFormGroup = this.applicationForm.get('checklist') as FormGroup;
      // Remove Previous Checklist Controls
      Object.keys(checklistFormGroup.controls).forEach(control => {
        checklistFormGroup.removeControl(control);
      });
    this.settingsService.getChecklistConfigForFacilityTypeProductTypeAppCategoryAndFacilityCategory(selectedType, productTypeId,
      1, null,null).subscribe(
          res => {
            let itemValue;
            if (res.length) {
              this.checklists = res.filter(c => c.active);
              this.checklists.forEach(item => {

                itemValue = this.returnFormValues(item);
                if (item.required) {
                  checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue, [Validators.required]));
                } else {
                  checklistFormGroup.addControl(item.checklist.id.toString(), new FormControl(itemValue));
                }
              });

              this.noChecklistAvailable = !this.checklists.length;

            }else {
             this.noChecklistAvailable = true;
            }
          }
      );
  }


  returnFormValues(item) {
    const checklistFormGroup = this.applicationForm.get('checklist') as FormGroup;
    if (this.editMode) {
      const idx = this.appDetail.checkListItems.findIndex(it => { return item.checklistID === it.checklistID; });
      if (idx > -1) {
        return this.appDetail.checkListItems[idx].checkListValue.name;
      }
    }
    return  checklistFormGroup.get(item.checklist.id.toString()) ? checklistFormGroup.get(item.checklist.id.toString()).value : '';
  }

  repopulateRefList() {
    this.uploader.clearQueue();
    this.documents = [];
    const facilityTypeId = this.applicationForm.value.facility.facilityTypeID;
    const productTypeId = this.applicationForm.value.facility.productTypeID;

    const focal = this.isApplicantFocalPerson();

    const organizationTypeID = this.applicationForm.value.facility.organizationTypeID;

    const selectedType = this.ownershipTypes.find(function (x) {
      return x.id === organizationTypeID;
    });
    if (!selectedType) {
      return;
    }
    // const focal = (this.applicationForm.value.facility.applicationTypeID === 3)
    const plc = (selectedType.organizationTypeCode === Constants.PLC);

    var foodManDoc: FoodManufDoc = null;

    const facilityType = this.facilityTypes.find(f => f.id === this.applicationForm.value.facility.facilityTypeID);
    const productType = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);

    if (facilityType.name === Constants.MANUFACTURER && productType.name === Constants.PRODUCT_TYPE_FOOD) {

      foodManDoc = { mLevelID: this.applicationForm.value.facility.mLevelID, mRLevelID: this.applicationForm.value.facility.mrLevelID };

    }
    // fetch required docs
    this.appService.getDocumentRef(facilityTypeId, productTypeId, plc, focal,
      this.appDetail ? this.appDetail.applicationCategory : null,
      this.appDetail ? this.appDetail.facility.facilityCategoryID : null,foodManDoc).subscribe(
      documents => {
        this.documentRefs = documents;
        const restrictedDocs = this.documentRefs.filter(function (x) {
          return x.required === true;
        });
        const hasPaymentRef = restrictedDocs.filter(doc=> {return doc.id === 35}).length > 0; 
        this.restrictedDocRefCount = restrictedDocs.length;
      
        if(this.appDetail){
          this.appDetail.isLegacyData && hasPaymentRef ? this.restrictedDocRefCount-- : null;
        }
      }
    );

  }

  riskLevelChange() {
    const mrLevel = this.mRLevels.find(x => x.id === this.applicationForm.value.facility.mrLevelID);

    if (!mrLevel) {
      return;
    }

    this.repopulateRefList();
    this.fetchConfiguredProfessionals();
  }

  manufacturingLevelChange() {
    const manufacturingLevel = this.mLevels.find(m => m.id ===  this.applicationForm.value.facility.mLevelID);
    if(!manufacturingLevel){
      return;
    }
    if (manufacturingLevel.mLevelTypeCode !== Constants.HIGHER_MANUFACTURING) {
      this.mRLevels = this.allmRLevels.filter(mrl => mrl.mrLevelTypeCode != Constants.MANUFACTURING_RISK_LEVEL_SPECIAL);
    }else {
      this.mRLevels = this.allmRLevels;
    }

    this.riskLevelChange();
	
	const facilityType = this.facilityTypes.find(f => f.id === this.applicationForm.value.facility.facilityTypeID);
    const productType = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
	if(facilityType.name === Constants.MANUFACTURER && productType.name === Constants.PRODUCT_TYPE_COSMETICS){
		this.fetchConfiguredProfessionals();
	}
  }

  isApplicantFocalPerson() {
    return this.accService.isApplicantFocalPerson();
  }

  applyApplicantNameOnProfession() {
    const applicantType = this.accService.getUserApplicantType();

    if (applicantType === Constants.TECHNICAL_MANAGER) {
      this.applicationForm.get('professionals').get('tlName').setValue(this.erisLoginService.getProfile().given_name);
      this.applicationForm.get('professionals').get('tlName').updateValueAndValidity();
    }
  }

  onWhenAddingFileFailed(item: FileLikeObject, filter: any, options: any) {
    switch (filter.name) {
      case 'fileSize':
        this.uploadErrorMessage = `Maximum upload size exceeded ( ${(item.size / (1024 * 1024)).toFixed(1)} MB uploaded,
         ${(this.maxFileSize / ( 1024 * 1024)).toFixed(1)} MB allowed)`;
        break;
      case 'fileType':
        const allowedTypes = this.allowedFileType.join();
        this.uploadErrorMessage = `Type '${item.type} is not allowed. Allowed types: '${allowedTypes}'`;
        break;
      default:
        this.uploadErrorMessage = `Unknown error (filter is ${filter.name})`;
    }
  }

  sortHierarchy = function (id: number, source: string) {
    switch (source) {
      case 'regionID':
        this.commonService.getZoneTypesByRegion(id).subscribe(zoneTypes => {
          this.zoneTypes = zoneTypes ;
        });
        break;
      case 'zoneID':
        this.commonService.getWoredaTypesByZone(id).subscribe(woredaTypes => {
          this.woredaTypes = woredaTypes ;
        });
        break;
      default:
        break;
    }
  };

  updateHierarchyLists(adminBoundary: any, source: string) {
    let selectedBoundaryID: number = -1;

    if (adminBoundary !== undefined) {

      selectedBoundaryID = adminBoundary !== null ? adminBoundary.id : selectedBoundaryID;
      switch (source) {

        case 'regionID':
          adminBoundary = <RegionType>adminBoundary;
          this.applicationForm.controls.location['controls'].zoneID.setValue(null);
          this.applicationForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(selectedBoundaryID, source);
          this.woredaTypes = [];
          break;

        case 'zoneID':
          adminBoundary = <ZoneType>adminBoundary;
          this.applicationForm['controls'].location['controls'].woredaID.setValue(null);
          this.sortHierarchy(selectedBoundaryID, source);
          break;
      }
    }

  }


  specificProductChanges() {
    if (this.applicationForm.value.facility.specificProductIDs.indexOf(0) !== -1) {
      // This means 'Other' is selected, so we remove the selected specific products
      this.applicationForm.get('facility').get('specificProductIDs').setValue([0]);
    }

    this.commonService.getFilteredSpecificProductItems(this.applicationForm.value.facility.specificProductIDs)
      .subscribe(specificProductItems => this.specificProductItems = specificProductItems);

  }

  addOtherCity() {
    let otherCityName = this.otherCity.nativeElement.value;
    if (otherCityName === '') {
      return;
    }
    let existingCity = this.cities.find(c => c.name.trim().toLowerCase() === otherCityName.trim().toLowerCase() );
    if (existingCity !== undefined) {
      this.applicationForm.get('location').get('cityID').setValue(existingCity.id);
      return;
    }
    const city = new City();
    city.name = otherCityName;
    this.commonService.addCity(city).subscribe(
      resp => {
        this.commonService.getCities().subscribe(
          cities => {
            this.cities = cities;
            let newEltId = this.cities.find( c => c.name === otherCityName).id;
            this.applicationForm.get('location').get('cityID').setValue(newEltId);
          });
      });
  }

  setSpecificProductValidator(productType, facilityType) {
    if ([Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES, Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
      Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE,Constants.PRODUCT_TYPE_MEDICAL_GAS].indexOf(productType.name) !== -1) {
      this.showSpecificProduct = false;
      this.applicationForm.get('facility').get('specificProductIDs').clearValidators();
      this.applicationForm.get('facility').get('specificProductIDs').updateValueAndValidity();
      this.applicationForm.get('facility').get('specificProductIDs').setValue([]);
    } else {
       productType.name.indexOf(Constants.PRODUCT_TYPE_COSMETICS) > -1 && facilityType.name !== Constants.MANUFACTURER ? 
       this.applicationForm.get('facility').get('specificProductItemIDs') : 
       this.applicationForm.get('facility').get('specificProductItemIDs').clearValidators();

      this.applicationForm.get('facility').get('specificProductItemIDs').updateValueAndValidity();
      this.showSpecificProduct = true;
      this.applicationForm.get('facility').get('specificProductIDs');
      this.applicationForm.get('facility').get('specificProductIDs').updateValueAndValidity();
    }
  }

  onStoreManagerQualificationChange(pharmacistSelected: boolean) {
    if (pharmacistSelected) {
      const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
      if ([Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
      Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(product.name) !== -1) {
        this.smLetterOfExperienceDocRequired = false;
      }
    } else {
      this.smLetterOfExperienceDocRequired = true;
    }
  }

  // used to set the qualification dropdown data and minimum experience for Technical Leader and Store Manager
  checkFacilityAndProductTypeCombination(facilityTypeName, productTypeName) {
    return (facilityTypeName === Constants.IMPORTER && [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES,
        Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES].indexOf(productTypeName) !== -1) ||
        (facilityTypeName === Constants.WHOLESALER && [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES,Constants.PRODUCT_TYPE_MED_DEVICES]
          .indexOf(productTypeName) !== -1);
  }
  
  spItemChange() {
    this.fetchConfiguredProfessionals();
  }

  inputIsDisabled(inputValue) {
    if (this.appDetail) {
      return this.appDetail.isLegacyData && !(inputValue.value === null || inputValue.value === '' || inputValue.value === undefined || (inputValue.value['length'] != undefined && inputValue.value.length === 0)) &&
        !inputValue.dirty;
    }
    return false;
  }

  fetchConfiguredProfessionals() {
    this.professionalTypeConfigList = [];
    let professionalConfigFilter = new ProfessionalConfigFilter();
    professionalConfigFilter.applicationCategoryID = 1; // id for new application

    professionalConfigFilter.facilityTypeID = this.applicationForm.value.facility.facilityTypeID;
    professionalConfigFilter.productTypeID = this.applicationForm.value.facility.productTypeID;

    const product = this.productTypes.find(p => p.id === this.applicationForm.value.facility.productTypeID);
    if (product && [Constants.PRODUCT_TYPE_FOOD, Constants.PRODUCT_TYPE_COSMETICS].indexOf(product.name) !== -1) {
      // we dont want other manufacturers to send this values
      // cosmetics manufacturers don't have manufacturing risk level value so will not affect anything
      professionalConfigFilter.manufacturingRiskLevelID = this.applicationForm.value.facility.mrLevelID;
      professionalConfigFilter.manufacturingLevelID = this.applicationForm.value.facility.mLevelID;
    } 
    
    if (this.applicationForm.value.facility.specificProductItemIDs &&
      this.applicationForm.value.facility.specificProductItemIDs.length > 0) {
      professionalConfigFilter.specificProductItemIDs = this.applicationForm.value.facility.specificProductItemIDs;
    }
    this.settingsService.getProfessionalConfigListForApplicant(professionalConfigFilter).subscribe( res => {
      this.professionalTypeConfigList = res;
      this.createProfessionalForm();
    }, err => {

    }, () => {

    });
  }

  createProfessionalForm() {
    Object.keys((this.applicationForm.get('professionals') as FormGroup).controls).forEach(key => {
      this.applicationForm.get('professionals').get(key).clearValidators();
      this.applicationForm.get('professionals').get(key).updateValueAndValidity();
    });

    if (!this.editMode) {
      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {
          (this.applicationForm.get('professionals') as FormGroup).addControl(
            this.formatControlName(profConfig, pf),
            new FormControl(undefined, null));
  
            if (pf.professionalField.dataType === 'phoneNumber') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(NumberValidator.isPhoneNumber);
  
            } else if (pf.professionalField.dataType === 'email') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.email);
            }
            
            if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.min(0));
            }
        });
      });
    } else {
      const allProfessionals = this.appDetail.professionals[0];
      this.professionalTypeConfigList.forEach(profConfig => {
        profConfig.professionalFieldConfig.filter(pfc => pfc.active).forEach( pf => {

          this.fieldValue = allProfessionals[this.formatControlName(profConfig, pf)];
          let fieldValueExistsInLookup = true;

          if (pf.professionalField.professionalFieldCode === Constants.EDUCATION_LEVEL_CODE) {
            fieldValueExistsInLookup = Boolean(profConfig.educationLevelConfig.find(elc => elc.educationLevelID === this.fieldValue));
          }

          (this.applicationForm.get('professionals') as FormGroup).addControl(
            this.formatControlName(profConfig, pf),
            new FormControl(fieldValueExistsInLookup ? this.fieldValue : null, null));        

            if (pf.professionalField.dataType === 'phoneNumber') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(NumberValidator.isPhoneNumber);
  
            } else if (pf.professionalField.dataType === 'email') {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.email);
            }
            
            if (pf.professionalField.name === Constants.EXPERIENCE_LABEL) {
              (this.applicationForm.get('professionals') as FormGroup).get(this.formatControlName(profConfig, pf))
                .setValidators(Validators.min(0));
            }
        });
      });
    }
  }

  formatControlName(profTypeConfig, field) {
    return profTypeConfig.professionalType.professionalTypeCode.toLowerCase() + field.professionalField.name.replace(/ /g, '')
    + (field.professionalField.dataType === 'lookup' ? 'ID' : '');
  }
}
